import { DsButton } from '@frontends/ds';
import { type BaseSyntheticEvent, memo } from 'react';
import { useTranslation } from 'react-i18next';

export const OnboardingVerify = memo(function OnboardingVerify({
  sumSubUrl,
  handleClickVerify,
  isFetching,
}: {
  sumSubUrl?: string;
  handleClickVerify: (e?: BaseSyntheticEvent) => void;
  isFetching: boolean;
}) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-5">
      <span>
        {t('sum_sub_verify')}
        {!sumSubUrl && <>{t('sum_sub_generating')}</>}
      </span>
      <DsButton size="lg" onPress={() => handleClickVerify()} className="w-full" isPending={isFetching}>
        {!sumSubUrl ? t('refresh') : t('verify_now')}
      </DsButton>
    </div>
  );
});
